import { Controller as BaseController } from '@hotwired/stimulus';

export default class extends BaseController {
  static targets = ['reviewPopover', 'missionPopover'];
  static values = { link: String };

  toggleReviewPopover(event) {
    event.preventDefault();
    event.stopPropagation();

    // Close all other review popovers and reset z-index
    const allReviewPopovers = document.querySelectorAll(
      '[data-v3--trail-button--controller-target="reviewPopover"]',
    );
    allReviewPopovers.forEach((otherPopover) => {
      if (otherPopover !== this.reviewPopoverTarget) {
        otherPopover.style.display = 'none';
        otherPopover.classList.add('tw-hidden');
        otherPopover.dataset.wasClosed = 'true';
        // Reset z-index of parent button wrapper
        const buttonWrapper = otherPopover.closest('[data-trail-button]');
        if (buttonWrapper) {
          buttonWrapper.style.zIndex = '';
        }
      }
    });

    // Toggle current popover
    const wasClosed = this.reviewPopoverTarget.dataset.wasClosed === 'true';
    if (
      !wasClosed ||
      this.reviewPopoverTarget.style.display === 'none' ||
      this.reviewPopoverTarget.classList.contains('tw-hidden')
    ) {
      this.reviewPopoverTarget.style.display = 'flex';
      this.reviewPopoverTarget.classList.remove('tw-hidden');
      this.reviewPopoverTarget.dataset.wasClosed = 'false';
      // Increase z-index of parent button wrapper
      const buttonWrapper = this.reviewPopoverTarget.closest('[data-trail-button]');
      if (buttonWrapper) {
        buttonWrapper.style.zIndex = '999999999';
      }
    } else {
      this.reviewPopoverTarget.style.display = 'none';
      this.reviewPopoverTarget.classList.add('tw-hidden');
      // Reset z-index of parent button wrapper
      const buttonWrapper = this.reviewPopoverTarget.closest('[data-trail-button]');
      if (buttonWrapper) {
        buttonWrapper.style.zIndex = '';
      }
    }
  }

  closeReviewPopover(event) {
    event.preventDefault();
    event.stopPropagation();

    this.reviewPopoverTarget.style.display = 'none';
    this.reviewPopoverTarget.classList.add('tw-hidden');
    this.reviewPopoverTarget.dataset.wasClosed = 'true';
    // Reset z-index of parent button wrapper
    const buttonWrapper = this.reviewPopoverTarget.closest('[data-trail-button]');
    if (buttonWrapper) {
      buttonWrapper.style.zIndex = '';
    }
  }

  handleMissionClick(event) {
    const wasClosed = this.missionPopoverTarget.dataset.wasClosed === 'true';
    if (!wasClosed) {
      // If popover wasn't closed, navigate to the link
      window.location.href = this.linkValue;
    } else {
      // Show popover
      event.preventDefault();
      this.missionPopoverTarget.style.display = 'flex';
      this.missionPopoverTarget.dataset.wasClosed = 'false';
      // Increase z-index of parent button wrapper
      const buttonWrapper = this.missionPopoverTarget.closest('[data-trail-button]');
      if (buttonWrapper) {
        buttonWrapper.style.zIndex = '999999999';
      }
    }
  }

  closeMissionPopover(event) {
    event.preventDefault();
    event.stopPropagation();

    this.missionPopoverTarget.style.display = 'none';
    this.missionPopoverTarget.dataset.wasClosed = 'true';
    // Reset z-index of parent button wrapper
    const buttonWrapper = this.missionPopoverTarget.closest('[data-trail-button]');
    if (buttonWrapper) {
      buttonWrapper.style.zIndex = '';
    }
  }
}
